import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

interface Props {
  tabs: {
    title: string;
    text: string;
  }[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TipsSectionTabs',
  props: {
    tabs: null
  },
  setup(__props: any) {



const currentTab = ref<null | number>(null);
const handleClick = ({ index }: { index: number | null }) => {
  currentTab.value = index === currentTab.value ? null : index;
};

return { __sfc: true,currentTab, handleClick }
}

})